import { Station } from '@mi-front/core';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Chip, ChipProps } from '@mui/material';
import { StationAvatar } from './StationAvatar';

export interface StationsNavigatorLinkProps {
  readonly station: Station | undefined;
  readonly onClick: () => void;
  readonly size?: ChipProps['size'];
}

export const StationsNavigatorLink = (props: StationsNavigatorLinkProps) => {
  const { station, onClick, size = 'medium' } = props;

  if (!station) {
    return null;
  }

  return (
    <Chip
      variant="outlined"
      size={size}
      avatar={<StationAvatar stationId={station.id} />}
      label={station.name}
      onClick={onClick}
      onDelete={onClick}
      deleteIcon={<ArrowDropDownIcon />}
      clickable
    />
  );
};
